
export default {
  list: [],
  createRecord: null
}



// WEBPACK FOOTER //
// ./src/store/modules/medical-record/state.js